import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// Copyright 2017-2021 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { combineLatest, of } from '@polkadot/x-rxjs';
import { map, switchMap } from '@polkadot/x-rxjs/operators';
import { SignedBlockExtended } from "../type/index.mjs";
import { memo } from "../util/index.mjs";
/**
 * @name subscribeNewBlocks
 * @returns The latest block & events for that block
 */

export function subscribeNewBlocks(instanceId, api) {
  return memo(instanceId, function () {
    return api.derive.chain.subscribeNewHeads().pipe(switchMap(function (header) {
      var blockHash = header.hash;
      return combineLatest(api.rpc.chain.getBlock(blockHash), api.query.system.events.at(blockHash), of(header.validators));
    }), map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 3),
          block = _ref2[0],
          events = _ref2[1],
          validators = _ref2[2];

      return new SignedBlockExtended(api.registry, block, events, validators);
    }));
  });
}